module.exports = __webpack_public_path__ + "static/img/time-lamp-desktop.201009be.svg";